import { useInvalidateReturnRequest } from "@babackapp/private-api-client/client/use-invalidate-return-request";
import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { ShopDto } from "../generated/schema";

export default function useStripeIntegrationPaymentRefundMutation(
  shop: ShopDto,
) {
  const queryClient = useQueryClient();

  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const invalidateReturnRequest = useInvalidateReturnRequest();

  const mutation = $api.useMutation(
    "post",
    "/shops/{shopId}/integrations/stripe/payment-intent/{paymentIntentId}/refund",
  );

  return useMutation({
    onSuccess: async (_, variables) => {
      await queryClient.invalidateQueries({
        queryKey: [
          "get",
          "/shops/{shopId}/integrations/stripe/payment-intent/{paymentIntentId}",
          {
            params: {
              path: {
                shopId: shop.id,
                paymentIntentId: variables.paymentIntentId,
              },
            },
          },
        ],
        refetchType: "all",
      });

      invalidateReturnRequest({
        returnRequestId: variables.returnRequestId,
        shopId: shop.id,
      });
      successNotification();
    },
    onError: () => {
      errorNotification();
    },
    mutationFn: async (variables: {
      paymentIntentId: string;
      amount: number;
      returnRequestId: string;
    }) => {
      return mutation.mutateAsync({
        params: {
          path: { shopId: shop.id, paymentIntentId: variables.paymentIntentId },
        },
        body: {
          amount: variables.amount,
          returnRequestId: variables.returnRequestId,
        },
      });
    },
  });
}
